// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".title-box[data-v-4ff3a2db] {\n  padding-left: 20px;\n  font-size: 14px;\n  cursor: pointer;\n  margin-right: 15px;\n}\n.icon-back-box[data-v-4ff3a2db] {\n  width: 16px;\n  height: 16px;\n}\n", ""]);
// Exports
module.exports = exports;
